module.exports = __webpack_public_path__ + "img/solution_partner_nh@2x.0b1a3ff3.png";